import { render, staticRenderFns } from "./EditStreamsCards.vue?vue&type=template&id=67088e89&"
import script from "./EditStreamsCards.vue?vue&type=script&lang=js&"
export * from "./EditStreamsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports